module.exports = __webpack_public_path__ + "static/media/88x31.99974d79.gif";